/**
 * admins.js — list of GAT email addresses with admin privileges in GlobalOps.
 *
 * The bootstrap list: these are always admin, whatever their users-registry
 * row says (AuthContext.isAdmin(), getRole() below). Everyone else gets a role
 * in the Team page - no code change needed.
 *
 * To grant admin: add the email (lowercase) to ADMIN_EMAILS.
 * To revoke:      remove it.
 */
export const ADMIN_EMAILS = ['a.sharif@globalat.com'];

export const isAdmin = (email) => !!email && ADMIN_EMAILS.includes(email.trim().toLowerCase());

/**
 * Combined admin check: the bootstrap ADMIN_EMAILS list OR a role='admin' row
 * in the users registry. Lets the Team panel grant admin to a teammate without
 * a code change, while a.sharif (in ADMIN_EMAILS) is always admin.
 */
export const isAdminUser = (email, users = []) => {
  if (isAdmin(email)) return true;
  const e = (email || '').trim().toLowerCase();
  return users.some((u) => (u.email || '').toLowerCase() === e && u.role === 'admin');
};

/**
 * Resolve a user's effective role: one of
 * 'admin' | 'operations' | 'manager' | 'engineer-sales' | 'crm-staff' |
 * 'engineer' | 'pending'.
 * Bootstrap admins (ADMIN_EMAILS) always resolve to 'admin' regardless of their
 * registry row. Otherwise the users-registry role passes through verbatim; an
 * unknown user (no row yet) is treated as 'pending'. Used for role-based nav +
 * view routing (see src/data/roles.js for the capability map).
 */
export const getRole = (email, users = []) => {
  if (isAdmin(email)) return 'admin';
  const e = (email || '').trim().toLowerCase();
  const hit = users.find((u) => (u.email || '').toLowerCase() === e);
  if (!hit) return 'pending';
  return hit.role || 'pending';
};
